

























import VueOptions from '@utils/VueOptions'
import ActivationPlanDisplay from './ActivationPlanDisplay'

settings =
  name: 'ActivationRangeWrapper'

  vue:
    props: ['item', 'activationPlan', 'actions', 'options']

    components: {
      ActivationPlanDisplay,
    }

    data: ->
      addingToCart: false

    computed:
      displaySyncIndicator: ->
        @item.marked_for_sync || @item.marked_as_syncing

      addToCartTooltip: ->
        if @displaySyncIndicator
          return 'This listing is being updated - you can still add this, however some values may change'
        'Exact quantity and addons may be adjusted after adding to cart'

    methods:
      hiAddToCartTrigger: ->
        @addingToCart = true
        @actions.addToCartTrigger()

export default VueOptions.vue settings
